
export class SaveSearchModel {
    searchName: string = '';
    type: string;
    sendEmailUpdates: boolean = false;
    isPublic: boolean = false;
    tags: number[] = [];
}
